import * as React from 'react';

import { Version } from './index.styles';

export const ApplicationVersion: React.FC = () => {
    return <Version>v{process.env.VERSION}</Version>;
};
